var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDtLogoMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419 314.5",
    style: {
      enableBackground: "new 0 0 419 314.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.8,142L299,72.5c-21.8-9.2-47-16.8-74.8-22.7l-7.7,44C252,105.7,277.6,122.6,286.8,142z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.4,89.4l7.5-42.5C198,45,186.8,43.4,175.3,42l-7.1,40.3C179.9,84.2,190.9,86.6,201.4,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.7,80l7-39.7c-8.5-0.8-17.1-1.4-25.8-1.9L127,77.6C135.8,78.2,144.4,79,152.7,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.9,158.1c0-30.1-26.1-57.7-69.2-78.8l-29.9,170.2C344.4,227.4,382.9,194.7,382.9,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.8,239.5c-0.1,0-0.1,0-0.2,0l-6.9,39.1c2.3,0,4.7,0.1,7,0.1c6.4,0,12.8-0.1,19.1-0.3l7-39.7 C116.4,239.1,107.7,239.5,98.8,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.8,229l-7.7,44c29.7-4,57.3-10.1,81.9-17.7l12.2-69.7C263.5,204,232.6,219.4,192.8,229z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141,237.4l-7.1,40.3c11.9-0.6,23.5-1.5,34.9-2.8l7.4-42.5C165,234.6,153.2,236.3,141,237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.8,37.5c-0.6,0-1.3,0-2,0c-5.3,0-10.6,0.1-15.9,0.2l-7,39.7L46.2,236.3l-7,39.7c5.2,0.5,10.4,0.9,15.7,1.2 c7,0.5,14,0.8,21.1,1l6.9-39.1L111.3,77l6.9-39.1C111.8,37.7,105.3,37.5,98.8,37.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtLogoMobile);
export default __webpack_public_path__ + "static/media/DTLogoMobile.bddfe8e983ec8c74f5e15e23d5e4f9f1.svg";
export { ForwardRef as ReactComponent };